module.exports = __webpack_public_path__ + "src/app/_content/MOTFonts/BMWMotorradW01-HeavyItalic.eot?533a1834ab45463b9472e30ee2ec2612";